import { Cloud, CloudLightning, CloudRain, CloudSnow, Sun } from 'lucide-react';
import type { WeatherSnapshot } from '../types';

const ICONS: Record<WeatherSnapshot['condition'], typeof Sun> = {
    ensoleille: Sun,
    nuageux: Cloud,
    pluie: CloudRain,
    neige: CloudSnow,
    orage: CloudLightning,
};

const COLORS: Record<WeatherSnapshot['condition'], string> = {
    ensoleille: 'text-amber-400',
    nuageux: 'text-slate-400',
    pluie: 'text-sky-400',
    neige: 'text-sky-300',
    orage: 'text-violet-400',
};

const LABELS: Record<WeatherSnapshot['condition'], string> = {
    ensoleille: 'Ensoleillé',
    nuageux: 'Nuageux',
    pluie: 'Pluie',
    neige: 'Neige',
    orage: 'Orage',
};

/**
 * Icône météo du jour, à côté du message d'accueil. Purement décorative :
 * absente si la dernière lecture a échoué (voir weather.service.ts côté API),
 * ce qui n'est jamais traité comme une erreur par le reste de la page.
 */
export function WeatherIcon({ weather }: { weather: WeatherSnapshot }) {
    const Icon = ICONS[weather.condition];

    return (
        <span
            className="inline-flex items-center gap-1 text-[var(--color-text-secondary)]"
            title={`${LABELS[weather.condition]} à Paris, ${weather.temperatureC}°C`}
        >
            <Icon className={`w-6 h-6 ${COLORS[weather.condition]}`} aria-hidden />
            <span className="text-sm font-medium tabular-nums">{weather.temperatureC}°</span>
        </span>
    );
}
